<template>
    <div class="pd15 tableScope equipmentList">
        <!-- <div v-if="JSON.stringify(equipment) !='{}'"> -->
        <div class="panel bgPanel">
            <div class="navBtn">
                <div class="tabBar style-tabBar cb bdSub-bottom active-c-main_E tra-fast_E">
                    <button v-for="(item,index) in btnGroup_equipment" :key="index" class="cSub"  :class="{active:index==deviceIndex}" @click="changeTab(index)">{{item.title}}</button>
                </div>
            </div>
            <div v-if="deviceIndex==0">
                <div class="table table-5x tra-fast posR"  fillHeight="lastHeight,-#viewPlant .equipmentList .devicePage" v-permissions="'A/C/A'" permission-type="none">
                    <loading v-show="isEmpty" ></loading>
                    <div class="cb" v-show="equipment.length">
                    <!-- <div class="cb" v-show="equipment && equipment.length"> -->
                        <div class="tableSys head noSelect cField bdLight-bottom" >
                            <div class="w8x">{{$t('word215',['设备状态'])}}</div>
                            <div>{{$t('word693',['名称'])+'/'+$t('word58',['序列号'])}}</div>
                            <!-- <div>通信方式</div> -->
                            <!-- <div>信号强度</div> -->
                            <div>{{$t('word255',['连接设备'])+'('+$t('cmd19',['全部'])+'/'+$t('word64',['离线'])+')'}}</div>
                            <div>{{$t('word701',['最近更新时间'])}}</div>
                            <div v-permissions="'A/C/D'"  permission-type="none">{{$t('word47',['操作'])}}</div>
                        </div>
                        <div class="fixedScrollBar scrollY tra-fast"  fillHeight="lastHeight,-#viewPlant .equipmentList .devicePage" scroll>
                            <table >
                                <thead class="head-token">
                                    <tr>
                                        <th class="w8x"></th>
                                        <th></th>
                                        <!-- <th></th> -->
                                        <!-- <th></th> -->
                                        <th></th>
                                        <th></th>
                                        <th v-permissions="'A/C/D'"  permission-type="none"></th>
                                    </tr>
                                </thead>
                                <tbody class="bdLight-bottom_E emptyToken_EE ">
                                    <tr v-for="(item,index) in equipment" :key="index">
                                        <td><StatusIco :id="item.status" :type="'device'" class="statueIcon" v-if="item.status != null "></StatusIco> <span v-else>--</span></td>
                                        <td>
                                            <div><span v-if="item.name != null">{{item.name}}</span><span v-else>{{$t('word34',['采集器'])}}</span></div>
                                            <div><span v-if="item.sn != null">{{item.sn}}</span><span v-else>--</span></div>
                                        </td>
                                        <!-- <td><span v-if="item.networkType != null">{{item.networkType}}</span><span v-else>--</span></td> -->
                                        <!-- <td>
                                            <span v-if="item.signalStrength !=null">
                                                <svg class="ico"><use :xlink:href="'#ico-signal-'+item.signalStrength" /></svg>
                                            </span>
                                            <span v-else>--</span>
                                            <span v-if="item.networkOperator !=null">
                                                {{item.networkOperator}}
                                            </span>
                                            <span v-else>--</span>
                                        </td> -->
                                        <td class="pR">
                                                <div class="showInverter" @mouseenter.self="_showInverter(index,item.id,$event)">{{item.deviceTotal}}/{{item.deviceOffline}}</div>
                                                <transition name="fadeIn">
                                                    <div class="inverterStatus" v-show="item.showInverter" :style="{top:isBottom+'px'}" @mouseleave="closeInverter">
                                                         <!-- @mouseleave="closeInverter" -->
                                                        <!--  -->
                                                        <loading v-show="isNoResult"></loading>
                                                        <ul v-show="inverterData.length" >
                                                            <li  v-for="(attr,index) in inverterData" :key="index" >
                                                                <span>
                                                                    <StatusIco :id="attr.status" :type="'device'" class="statueIcon" v-if="attr.status != null "></StatusIco> <span v-else>--</span>
                                                                </span>
                                                                <span>{{getTypeText(attr.type,'deviceType')}}</span>
                                                                <span>{{attr.sn}}</span>
                                                            </li>
                                                        </ul>
                                                        <no-result v-if="!inverterData.length && !isNoResult"></no-result>
                                                    </div>
                                            </transition>
                                            </td>
                                        <td>
                                            <div v-if="item.lastUpdateTime!=null && JSON.stringify(DetailInfo) !='{}'">{{item.lastUpdateTime|time('%Y/%m/%d %H:%M','inc')}}<br>{{mz(DetailInfo.regionTimezone)}}</div>
                                            <div v-else>--</div>
                                                <!-- {{item.lastUpdateTime|time('%Y/%m/%d','inc')}} -->
                                            </td>
                                        <td v-permissions="'A/C/D'"  permission-type="none">
                                            <button class="hover-c-error hover-f-error" type="button" @click="_confirmDels(item.id,{deviceType:item.type,deviceStatus:item.status})" :title="$t('cmd9',['删除'])"  >
                                                <svg class="ico"><use xlink:href="#ico-recycle" /></svg>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <no-result v-if="pagination.total==0 && isEmpty==false"></no-result>
                    <!-- <no-result v-if="(!equipment || !equipment.length) && isEmpty==false"></no-result> -->
                </div>
                <div class="tableBatch cSub sPagination devicePage" :class="{disable:!pagination.total}" v-permissions="'A/C/A'"  permission-type="none">
                    <Pagination class="ml2x" :pagination="pagination" :getList="_getListPage"></Pagination>
                </div>
            </div>
            <div v-if="deviceIndex==1">
                <div class="table table-5x tra-fast posR"   fillHeight="lastHeight,-#viewPlant .equipmentList .deviceTwoPage" v-permissions="'A/C/A'" permission-type="none">
                    <loading v-show="isEmpty" ></loading>
                    <div class="cb" v-show="equipment && equipment.length">
                        <div class="tableSys head noSelect cField bdLight-bottom" >
                            <div class="w8x">{{$t('word215',['设备状态'])}}</div>
                            <div>{{$t('word693',['名称'])+'/'+$t('word58',['序列号'])}}</div>
                            <div>{{$t('word1370',['配置状态'])}}</div>
                            <div>{{$t('word1371',['应用于'])}}</div>
                            <div>{{$t('word697',['所属采集器'])}}</div>
                            <div>{{$t('word701',['最近更新时间'])}}</div>
                            <div>{{$t('word47',['操作'])}}</div>
                        </div>
                        <div class="fixedScrollBar scrollY tra-fast"  fillHeight="lastHeight,-#viewPlant .equipmentList .deviceTwoPage" scroll>
                            <table >
                                <thead class="head-token">
                                    <tr>
                                        <th class="w8x"></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
                                    <tr v-for="(item,index) in equipment" :key="index">
                                        <td><StatusIco :id="item.status" :type="'device'" class="statueIcon" v-if="item.status != null "></StatusIco> <span v-else>--</span></td>
                                        <td>
                                            <div><span v-if="item.name != null">{{item.name}}</span><span v-else>{{$t('word39',['电表'])}}</span></div>
                                            <div><span v-if="item.sn != null">{{item.sn}}</span><span v-else>--</span></div>
                                        </td>
                                        <td><span v-if="item.config">{{$t('word1372',['已配置'])}}</span><span v-else>{{$t('word1359',['未配置'])}}</span></td>
                                        <td>
                                            <span v-if="item.config && item.config.type">{{item.config.type=='THREE_PHASE'?getLanguageStr('plant_detail164','三相系统'):getLanguageStr('word1971','单相系统')}}</span>
                                            <span v-else>{{$t('word116',['无'])}}</span>
                                        </td>
                                        <td class="pR">
                                            <div>{{item.gatewaySn}}</div>
                                        </td>
                                        <td>
                                            <div v-if="item.lastUpdateTime!=null && JSON.stringify(DetailInfo) !='{}'">{{item.lastUpdateTime|time('%Y/%m/%d %H:%M','inc')}}<br>{{mz(DetailInfo.regionTimezone)}}</div>
                                            <div v-else>--</div>
                                                <!-- {{item.lastUpdateTime|time('%Y/%m/%d','inc')}} -->
                                            </td>
                                        <td>
                                            <button class="hover-c-error hover-f-error" type="button" @click="_meterSetup(item)" :title="getLanguageStr('word1769','电表配置')">
                                                <Icon name="setup" class="ico" />
                                            </button>
                                            <button v-permissions="'A/C/D'"  permission-type="none" class="hover-c-error hover-f-error" type="button" @click="_confirmDels(item.deviceId,{deviceType:item.type,deviceStatus:item.status})" :title="$t('cmd9',['删除'])">
                                                <svg class="ico"><use xlink:href="#ico-recycle" /></svg>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <no-result v-if="pagination.total==0 && isEmpty==false"></no-result>
                    <!-- <no-result v-if="(!equipment || !equipment.length) && isEmpty==false"></no-result> -->
                </div>
                <div class="tableBatch cSub sPagination deviceTwoPage" :class="{disable:!pagination.total}" v-permissions="'A/C/A'" permission-type="none">
                    <Pagination class="ml2x" :pagination="pagination" :getList="_getListPage"></Pagination>
                </div>
            </div>
            <div v-if="deviceIndex==2">
                <div class="table table-5x tra-fast posR"  fillHeight="lastHeight,-#viewPlant .equipmentList .deviceThreePage" v-permissions="'A/C/A'" permission-type="none">
                    <loading v-show="isEmpty" ></loading>
                    <div class="cb" v-show="equipment.length">
                    <!-- <div class="cb" v-show="equipment && equipment.length"> -->
                        <div class="tableSys head noSelect cField bdLight-bottom">
                            <div class="w8x">{{$t('word215',['设备状态'])}}</div>
                            <div>{{$t('word693',['名称'])+'/'+$t('word58',['序列号'])}}</div>
                            <!-- <div>通信方式</div> -->
                            <!-- <div>信号强度</div> -->
                            <div>{{$t('word697',['所属采集器'])}}</div>
                            <div>{{$t('word701',['最近更新时间'])}}</div>
                            <div v-permissions="'A/C/D'"  permission-type="none">{{$t('word47',['操作'])}}</div>
                        </div>
                        <div class="fixedScrollBar scrollY tra-fast"  fillHeight="lastHeight,-48" scroll>
                            <table >
                                <thead class="head-token">
                                    <tr>
                                        <th class="w8x"></th>
                                        <th></th>
                                        <!-- <th></th> -->
                                        <!-- <th></th> -->
                                        <th></th>
                                        <th></th>
                                        <th v-permissions="'A/C/D'"  permission-type="none"></th>
                                    </tr>
                                </thead>
                                <tbody class="bdLight-bottom_E emptyToken_EE ">
                                    <tr v-for="(item,index) in equipment" :key="index">
                                        <td><StatusIco :id="item.status" :type="'device'" class="statueIcon" v-if="item.status != null "></StatusIco> <span v-else>--</span></td>
                                        <td>
                                            <div><span v-if="item.name != null">{{item.name}}</span><span v-else>{{$t('word35',['逆变器'])}}</span></div>
                                            <div><span v-if="item.sn != null">{{item.sn}}</span><span v-else>--</span></div>
                                        </td>
                                        <!-- <td><span v-if="item.networkType != null">{{item.networkType}}</span><span v-else>--</span></td> -->
                                        <!-- <td>
                                            <span v-if="item.signalStrength !=null">
                                                <svg class="ico"><use :xlink:href="'#ico-signal-'+item.signalStrength" /></svg>
                                            </span>
                                            <span v-else>--</span>
                                            <span v-if="item.networkOperator !=null">
                                                {{item.networkOperator}}
                                            </span>
                                            <span v-else>--</span>
                                        </td> -->
                                        <td class="pR">
                                            <div>{{item.gatewaySn}}</div>
                                        </td>
                                        <td>
                                            <div v-if="item.lastUpdateTime!=null && JSON.stringify(DetailInfo) !='{}'">{{item.lastUpdateTime|time('%Y/%m/%d %H:%M','inc')}}<br>{{mz(DetailInfo.regionTimezone)}}</div>
                                            <div v-else>--</div>
                                                <!-- {{item.lastUpdateTime|time('%Y/%m/%d','inc')}} -->
                                            </td>
                                        <td v-permissions="'A/C/D'"  permission-type="none">
                                            <button class="hover-c-error hover-f-error" type="button" @click="_confirmDels(item.deviceId,{deviceType:item.type,deviceStatus:item.status})" :title="$t('cmd9',['删除'])">
                                                <svg class="ico"><use xlink:href="#ico-recycle" /></svg>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <no-result v-if="pagination.total==0 && isEmpty== false"></no-result>
                    <!-- <no-result v-if="(!equipment || !equipment.length) && isEmpty== false"></no-result> -->
                </div>
                <div class="tableBatch cSub sPagination" :class="{disable:!pagination.total}" v-permissions="'A/C/A'" permission-type="none">
                    <Pagination class="ml2x" :pagination="pagination" :getList="_getListPage"></Pagination>
                </div>
            </div>
        </div>
        <!-- </div> -->
    </div>
</template>
<script>
import {mapGetters, mapMutations, mapActions} from 'vuex';
import Pagination from '@/components/common/ui/Pagination.vue';
import NoResult from '@/components/common/ui/NoResult';
import Loading from '@/components/common/ui/Loading';
import StatusIco from '@/components/common/ui/StatusIco.vue';
import {getLanguageStr} from '@/util/language.js';

import * as lib from '@/util/lib.js';
// import {OperationCollector,OperationDelete,OperationCollectorStatus} from  "@/api/maintain/plant/list.js"
import * as listApi from '@/api/maintain/plant/list';

export default {
	components: {Pagination, NoResult, Loading, StatusIco},
	props: {
		DetailInfo: {
			type: Object,
			default: () => ({})
		}
	},
	data () {
		return {
			id: 'equipmentStation',
			requestData: [],
			delDeviceId: '',
			inverterData: [],
			isNoResult: true,
			isBottom: 0,
			btnGroup_equipment: [
				{title: getLanguageStr('word34', '采集器')},
				{title: getLanguageStr('word39', '电表')},
				{title: getLanguageStr('word35', '逆变器')}
			],
			// deviceIndex:0,
			collectDevice: []
		};
	},
	computed: {
		...mapGetters({
			deviceStatus: 'equipment/deviceStatus',
			equipment: 'stationDetail/equipment',
			pagination: 'stationDetail/pagination',
			isEmpty: 'stationDetail/isEmpty',
			stationId: 'stationDetail/stationId',
			deviceIndex: 'stationDetail/deviceIndex'
		})
	},
	watch: {
		// deviceStatus(val){
		//     console.log(val)
		//    if(val==1){
		//        this._delDevice()
		//    }
		// }
	},
	mounted () {
		lib.setScroll($('#' + this.id + ' [scroll]'));
	},
	methods: {
		getLanguageStr,
		getTypeText: lib.getTypeText,
		...mapMutations({
			DEVICESTATUS: 'equipment/DEVICESTATUS',
			GET_ISEMPTY: 'stationDetail/GET_ISEMPTY',
			GET_DEVICEINDEX: 'stationDetail/GET_DEVICEINDEX'
		}),
		...mapActions({
			GetEquipment: 'stationDetail/GetEquipment'
		}),
		changeTab (index) {
			lib.loadingChange($('.equipmentList [loading]'), 'true'); // 删除设备后更新详情，所有loading变为false
			this.GET_DEVICEINDEX(index);
			let pages = {page: 1, size: 20, equipTabIndex: index};
			this.GetEquipment(pages).then(() => {
				setTimeout(() => {
					lib.fillHeight();
				}, 50);
				this.GET_ISEMPTY(false);
			}).catch(error => {
				this.GET_ISEMPTY(false);
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		_getListPage () {
			let pages = {page: this.pagination.request.page, size: this.pagination.request.size, equipTabIndex: this.deviceIndex};
			this.GetEquipment(pages);
		},
		mz (data) {
			return lib.getTimeZoneStr(data);
		},
		// 确定删除
		_confirmDels (data, deviceOption) {
			this.requestData = [data]; // 每次删除重新装载数据(deviceId)
			this.delDeviceId = data; // 每次删除重新赋值(deviceId)
			this.$emit('confirmDels', data, deviceOption);
			// let req={
			//     stationId:this.stationId
			// }
			// 获取采集器下的设备
			// listApi.OperationCollectorStatus(this.delDeviceId,req).then(res=>{
			//    for(let attr in res){
			//        this.collectDevice.push(res[attr].type)
			//    }
			//    this.collectDevice=[...new Set(this.collectDevice)]
			// },error=>{
			//     !_.isEmpty(error) && this.$notify(error)
			// })
		},
		// 删除
		_delDevice () {
			let apiName, delData;
			if (this.deviceIndex == 0) {
				apiName = 'OperationDelete';
				delData = this.requestData;
			} else {
				apiName = 'OperationDelete_equipment';
				delData = this.delDeviceId;
			}
			listApi[apiName](this.stationId, delData).then(response => {
				if (this.pagination.total % this.pagination.request.size == 1 && this.pagination.total > 1) {
					this.pagination.request.page = this.pagination.request.page - 1;
				}
				if (this.deviceIndex == 0) {
					if (response.inverterHint == true) {
						this.$emit('repeatSet', 'inverter');
					}
					if (response.meterHint == true) {
						this.$emit('repeatSet', 'meter');
					}
				} else if (this.deviceIndex == 1) {
					if (response.hintSettingStrategy == true) {
						this.$emit('repeatSet', 'meter');
					}
				} else {
					if (response.hintSettingStrategy == true) {
						this.$emit('repeatSet', 'inverter');
					}
				}
				this.DEVICESTATUS(0);
				this.GET_ISEMPTY(false);
				this._getListPage();
				// 重新刷新电站list
				this.$emit('update');
			}, error => {
				//  this.GET_ISEMPTY(false)
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		_meterSetup (meterInfo) {
			this.$emit('meterSetup', meterInfo);
		},
		// 隐藏浮框
		closeInverter () {
			this.inverterData = []; // 前次设备未读取完时再读新设备清空
			this.equipment.map(el => {
				el.showInverter = false;
			});
		},
		// 浮框
		_showInverter (index, id, event) {
			this.equipment[index].showInverter = true;
			this.isNoResult = true;
			this.showInverter = true;
			setTimeout(() => {
				let sonHeight = event.target.nextElementSibling.offsetHeight;
				if (document.documentElement.clientHeight - 48 - event.clientY < 200) {
					this.isBottom = document.documentElement.clientHeight - 48 - event.clientY + 30 - sonHeight;
				} else {
					this.isBottom = 0;
				}
				let req = {
					stationId: this.stationId
				};
				listApi.OperationCollectorStatus(id, req).then(response => {
					this.inverterData = response;
					this.isNoResult = false;
				}, error => {
					!_.isEmpty(error) && this.$notify(error);
				});
			});
		}
	}

};
</script>

<style  lang="scss" scoped >
.pd15{padding: 0 15px;}
.ico{width: 1.3em;height:1.3em}
.fixedScrollBar :deep(.mCSB_container){overflow: visible;}
.pR{position: relative;}
.inverterStatus{
    position: absolute;
    width: 300px;
    min-height: 200px;
    top:0;
    border-radius: 0.3rem;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background-color: #fff;
    -webkit-box-shadow: 0 0.2em 1em rgba(0, 0, 0, 0.1);
    box-shadow: 0 0.2em 1em rgba(0, 0, 0, 0.1);
    z-index: 9999;
    padding: 15px;
    ul>li{
        margin-bottom: 0.5em;
        span{
            display: inline-block;
            line-height: 1.5em
        }
        span:first-child{
            width: 1.5em;
            margin-right:0.5em;
            :deep(.statueIcon){
                vertical-align: middle
            }
        }
    }
    ul>li:last-child{
        margin-bottom:0
    }
}
.fadeIn-enter-active, .fadeIn-leave-active {
  transition: opacity .5s;
}
.fadeIn-enter, .fadeIn-leave-to /* .fade-leave-active 在低于版本 2.1.8 中 */ {
  opacity: 0;
}
.showInverter{
    cursor: pointer;
}
.svg-icon {
    width: 1.3em!important;
    height: 1.3em!important;
    vertical-align: inherit!important;
}
.bot{
    top: auto;
    bottom: 0
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/Equipment.vue